module.exports = __webpack_public_path__ + "img/icon5.85279b6a.svg";